"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentModelDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const content_model_json_1 = require("./content-model-json");
exports.ContentModelDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('ContentModel', content_model_json_1.ContentModelJsonMapper);
